import { gql } from "graphql-request";

const SERVER_GET_USER_SIMPLE = gql`
query GET_1_USER($id: ID!) {
  user(id: $id) {
    external
    profileId
    ...userFullInfo
    userBusinesses {
      id
      ...userBusinessGeneralInfo
      __typename
    }
    address {
      ...addressGeneralInfo
      __typename
    }
    avatar {
      ...uploadFileGeneralInfo
      __typename
    }
    company {
      ...companyGeneralInfo
      businesses {
        id
        name
        businessName
        rut
        logo {
          ...uploadFileGeneralInfo
          __typename
        }
        __typename
      }
      userFields {
        ...userFieldGeneralInfo
        __typename
      }
      __typename
    }
    __typename
  }
  users {
    id
    fullname
    __typename
  }
  syndicates {
    id
    name
    __typename
  }
}

fragment userFullInfo on User {
  id
  ...userRole
  role
  loginAsCompany
  currentVersion
  status
  forcePasswordChange
  username
  uiConfig
  afcConfig
  afcDate
  email
  businessEmail
  jobTitle
  jobTitleFamily
  area
  branchOffice
  userVersionId
  current
  version
  versionStatus
  fullname
  lastname
  initials
  identificationType
  rut
  firstname
  paternalLastname
  maternalLastname
  comment
  personalPhone
  birthday
  supervisor
  gender
  countryOfOrigin
  civilStatus
  genderPrevired
  nationalityPrevired
  gentilitie
  unemploymentInsuranceDate
  subjectToFamilyAllowance
  familyAllowanceSegment
  pensionStatus
  youngSubsidy
  simpleBurdens
  maternalBurdens
  disabledBurdens
  subjectToJudicialRetention
  validFrom
  validTo
  previsionType
  retirementScheme
  ipsReducedRate
  apviTaxCut
  apviPaymentType
  apviDocumentNumber
  cuenta2Capped
  isPrivateRole
  retired
  isDisabled
  healthInstitutionId
  pensionInstitutionId
  apviInstitutionId
  apvi2InstitutionId
  apvcInstitutionId
  cuenta2InstitutionId
  afpCollectId
  healthInstitutionCode
  pensionInstitutionCode
  apviInstitutionCode
  apvi2InstitutionCode
  apvcInstitutionCode
  cuenta2InstitutionCode
  healthPercentage
  pensionPercentage
  healthAmountUF {
    ...moneyGeneralInfo
    __typename
  }
  healthAmount {
    ...moneyGeneralInfo
    __typename
  }
  apviAmount {
    ...moneyGeneralInfo
    __typename
  }
  apvi2Amount {
    ...moneyGeneralInfo
    __typename
  }
  apvcAmount {
    ...moneyGeneralInfo
    __typename
  }
  cuenta2Amount {
    ...moneyGeneralInfo
    __typename
  }
  judicialAmount {
    ...moneyGeneralInfo
    __typename
  }
  healthInstitution {
    id
    value1
    __typename
  }
  pensionInstitution {
    id
    value1
    __typename
  }
  judicialRetentionPercentage
  healthCode
  apviContractCode
  apvi2ContractCode
  apvcContractCode
  cuenta2contractCode
  companyId
  __typename
}

fragment moneyGeneralInfo on Money {
  id
  value
  currencyId
  currency {
    id
    title
    abbreviation
    __typename
  }
  __typename
}

fragment userRole on User {
  id
  isAdmin
  isManager
  isSuperManager
  isBusinessManager
  external
  role
  __typename
}

fragment userBusinessGeneralInfo on UserBusiness {
  business {
    id
    name
    businessName
    rut
    email
    phone
    address {
      ...addressGeneralInfo
      __typename
    }
    businessRepresentatives {
      id
      firstname
      paternalLastname
      maternalLastname
      rut
      fullname
      __typename
    }
    __typename
  }
  id
  inPayroll
  privateRole
  currentVersion
  userBusinessVersionId
  current
  version
  versionStatus
  workPhone
  businessEmail
  firstAdmissionDate
  admissionDate
  validFrom
  validTo
  businessId
  userContracts {
    ...userContractGeneralInfo
    __typename
  }
  __typename
}

fragment userContractGeneralInfo on UserContract {
  id
  isCorporateSalary
  userContractVersionId
  costCenters {
    id
    percentage
    startDate
    endDate
    status
    userContractId
    costCenter {
      id
      name
      code
      startDate
      endDate
      __typename
    }
    __typename
  }
  contractSettlement {
    id
    dismissalCause {
      ...dismissalCauseInfo
      __typename
    }
    status
    isPayed
    issueDate
    displayToEmployee
    contractFinalDate
    publicComment
    comment
    __typename
  }
  contractAnnexes {
    id
    code
    title
    comment
    description
    createdAt
    contractAnnexFile {
      ...uploadFileGeneralInfo
      __typename
    }
    __typename
  }
  contractFile {
    ...uploadFileGeneralInfo
    __typename
  }
  versionStatus
  status
  secondaryStatus
  contractType
  userCode
  description
  comment
  currentVersion
  statusValues
  current
  initialDate
  finalDate
  version
  signatureIntegrationCode
  signatureDate
  signed
  area
  branchOffice
  jobTitle
  jobTitleFamily
  syndicate
  isSupervisor
  businessId
  unionFee
  infoJobTitle
  heavyWork
  activateNcontract
  healthAmountUF
  healthAmount
  healthInstitutionId
  healthPercentage
  heavyWorkTitle
  heavyWorkValue
  overdraft
  paymentPeriod
  monthlySalary {
    ...moneyGeneralInfo
    __typename
  }
  saturdayRate {
    ...moneyGeneralInfo
    __typename
  }
  sundayRate {
    ...moneyGeneralInfo
    __typename
  }
  holidayRate {
    ...moneyGeneralInfo
    __typename
  }
  weekdayRate {
    ...moneyGeneralInfo
    __typename
  }
  hoursPerWeek
  art22
  daysPerWeek
  supervisorId
  validFrom
  validTo
  code
  syndicateId
  areaId
  branchOfficeId
  departmentId
  journeyRbk
  jobTitleId
  jobTitleFamilyId
  syncAttendance
  syncAttendanceMark
  regionProvitionServiceCode
  comuneProvitionServiceCode
  taxTypeCode
  journeyTypeCode
  syncDigitalSign
  __typename
}

fragment dismissalCauseInfo on DismissalCause {
  id
  code
  art
  section
  subsection
  description
  __typename
}

fragment uploadFileGeneralInfo on UploadFile {
  id
  url
  hashName
  name
  mime
  ext
  createdAt
  updatedAt
  __typename
}

fragment addressGeneralInfo on Address {
  address
  postalCode
  commune
  city
  province
  region
  country
  __typename
}

fragment companyGeneralInfo on Company {
  id
  name
  description
  slug
  phone
  url
  email
  status
  logo {
    ...uploadFileGeneralInfo
    __typename
  }
  loginBackground {
    ...uploadFileGeneralInfo
    __typename
  }
  __typename
}

fragment userFieldGeneralInfo on UserField {
  id
  title
  type
  code
  editable
  description
  companyId
  tableId
  tableFieldId
  sorting
  createdAt
  updatedAt
  __typename
}
`;
export default SERVER_GET_USER_SIMPLE;
